export { default as DevelopmentSourcing } from './page';


// WEBPACK FOOTER //
// ./src/pages/developmentSourcing/index.js